<template>
<div class="flex w-52 items-center bg-white">
    <jet-label class="block text-base py-1 px-3" for="bank" value="Exibir" />
    <v-select :searchable="false" class="w-full p-2" placeholder="Qtd de itens"
    :options="sizeList" v-model="selectedOption" @input="$emit('input', selectedOption ? selectedOption.value : null)">
        <template slot="no-options">
            <div class="py-4 mt-1">
                Quantidade de itens por página
            </div>
        </template>
        <template slot="option" slot-scope="item">
            <div class="d-center">
                {{ item.label }}
            </div>
        </template>
        <template slot="selected-option" slot-scope="item">
            <div class="selected d-center">
                {{ item.label }}
            </div>
        </template>
    </v-select>
</div>
</template>

<script>
import JetLabel from "../../Jetstream/Label";
export default {
    components: {
        JetLabel
    },
    created: function() {
        let url = this.$page.url;
        let parseUrl = '';
        if(url.indexOf("size") > -1) {
            parseUrl = url.split('&');
            parseUrl.forEach(size => {
                if (size.indexOf("size") > -1){
                    this.selectedOption = parseInt(size.replace(/\D/gim, ''));
                    if (this.selectedOption > 100) {
                        this.selectedOption = 'Todos';
                    }
                }
            });
        }
    },
    data() {
        return {
            selectedOption: 10,
            sizeList: [{
                    label: "10",
                    value: 10
                },
                {
                    label: "20",
                    value: 20
                },
                {
                    label: "50",
                    value: 50
                },
                {
                    label: "100",
                    value: 100
                }
            ]
        };
    }
}
</script>

<style>

</style>
